import { ApolloError, makeVar } from '@apollo/client';

import { IJobPostingRecommendation } from '../../operations/query/students/useGetJobPostingRecommendations/useGetJobPostingRecomendations';

export interface IJobPostingRecommendationCache {
  error: ApolloError | undefined;
  data: IJobPostingRecommendation[];
}

export const emptyStudentLearningPathsCache: IJobPostingRecommendationCache = {
  error: undefined,
  data: [],
};

export const jobPostingRecommendationsVar = makeVar<IJobPostingRecommendationCache>(emptyStudentLearningPathsCache);
